export default __webpack_public_path__ + "static/media/logo.daf25649.ico";